(() => {
    Metro.i18n.add("zh-CN", {
        weekStart: 0,

        january: "一月",
        february: "二月",
        march: "三月",
        april: "四月",
        may: "五月",
        june: "六月",
        july: "七月",
        august: "八月",
        september: "九月",
        october: "十月",
        november: "十一月",
        december: "十二月",

        january_short: "1月",
        february_short: "2月",
        march_short: "3月",
        april_short: "4月",
        may_short: "5月",
        june_short: "6月",
        july_short: "7月",
        august_short: "8月",
        september_short: "9月",
        october_short: "10月",
        november_short: "11月",
        december_short: "12月",

        sunday: "星期日",
        monday: "星期一",
        tuesday: "星期二",
        wednesday: "星期三",
        thursday: "星期四",
        friday: "星期五",
        saturday: "星期六",

        sunday_short: "周日",
        monday_short: "周一",
        tuesday_short: "周二",
        wednesday_short: "周三",
        thursday_short: "周四",
        friday_short: "周五",
        saturday_short: "周六",

        sunday_short_2: "日",
        monday_short_2: "一",
        tuesday_short_2: "二",
        wednesday_short_2: "三",
        thursday_short_2: "四",
        friday_short_2: "五",
        saturday_short_2: "六",

        label_ok: "确定",
        label_cancel: "取消",
        label_done: "完成",
        label_today: "今天",
        label_now: "现在",
        label_clear: "清除",
        label_help: "帮助",
        label_yes: "是",
        label_no: "否",
        label_random: "随机",
        label_save: "保存",
        label_reset: "重置",
        label_submit: "提交",
        label_add_user_color: "添加到色板",
        label_send: "发送",
        label_accept: "接受",
        label_cookies_title: "本站使用cookies",
        label_cookies_text: "本网站使用cookies以确保您在我们的网站上获得最佳体验。",
        label_choose_file: "选择文件",
        label_drop_file: "点击或拖放文件到这里",
        label_files_selected: "已选择 {n} 个文件",

        label_days: "天",
        label_hours: "小时",
        label_minutes: "分钟",
        label_seconds: "秒",
        label_month: "月",
        label_months: "月",
        label_day: "日",
        label_year: "年",
        label_years: "年",

        label_rows_count: "显示：",
        label_search: "搜索：",
        label_table_info: "显示第 $1 到 $2 项，共 $3 项",
        label_prev: "上一页",
        label_next: "下一页",
        label_all: "全部",
        label_inspector: "检查器",
        label_goto_page: "前往",
        label_enter_page: "输入页码...",
        label_empty: "没有内容可显示",
        label_user_colors: "用户颜色",
        label_tiles: "磁贴",
        label_list: "列表",
        label_load_more: "加载更多",
        label_buy: "购买",
        label_buy_now: "立即购买",
        label_buy_today: "今日购买",
        label_download: "下载",
        label_search_results: "搜索结果",
        label_add: "添加",
        label_edit: "编辑",
        label_delete: "删除",
        label_new: "新建",
        label_sell: "出售",
        label_details: "详情",
        label_sorting: "排序",
        label_finish: "完成",
        label_play: "播放",
        label_pause: "暂停",
        label_stop: "停止",
        label_mute: "静音",
        label_loop: "循环",

        label_on: "开",
        label_off: "关",

        label_rename_tab: "重命名标签",
        label_close_tab: "关闭标签",
        label_close_other_tabs: "关闭其他标签",
        label_close_tabs_left: "关闭左侧标签",
        label_close_tabs_right: "关闭右侧标签",
        label_close_all_tabs: "关闭所有标签",
        label_close_inactive_tabs: "关闭非活动标签",

        label_clear_input: "清除输入",
        label_reveal_password: "显示密码",
        label_hide_password: "隐藏密码",
        label_generate_random: "生成随机值",
        label_search_input: "搜索输入的值",

        label_note: "备注",
        label_tip: "提示",
        label_info: "信息",
        label_warning: "警告",
        label_question: "问题",
        label_error: "错误",
        label_success: "成功",
        label_caution: "注意",
        label_alert: "警报",
        label_bug: "错误",
        label_fuck: "糟糕",
        label_important: "重要",
        label_shit: "糟糕",
        label_air: "空气",

        label_select_all: "全选",
        label_select_more: "选择...",
        label_select: "选择",
        label_filter: "筛选",

        label_collapse: "折叠",
        label_attach: "附加",
    });
})();
